const appleMapsLinks = [
  "https://maps.apple/p/TvUt.u9Xk5k-vH",
  "https://maps.apple/p/ZRxVyrCMwmkLWD",
  "https://maps.apple/p/YeIsmE_vBudI3n",
  "https://maps.apple/p/PK.WB-7qzJ4nS0",
  "https://maps.apple/p/sAKVdXGrk15kKv",
  "https://maps.apple/p/2v5UEraBhsXhKi",
  "https://maps.apple/p/LwIt1h3nWpxUFx",
  "https://maps.apple/p/gELJZHHq_o2-V2",
  "https://maps.apple/p/kp.8nsS4rx9ifV",
  "https://maps.apple/p/rJKQa8QT8Lao.E",
  "https://maps.apple/p/hxJg4nuxTuoLzU",
  "https://maps.apple/p/0M7rN75ZC8GsFk",
  "https://maps.apple/p/xzh7UQhLAD~IRe",
  "https://maps.apple/p/9HtTPjzIE_3oBC",
  "https://maps.apple/p/.Tqa2eG0YrrDv7",
  "https://maps.apple/p/i4bkL8xykB7QER",
  "https://maps.apple/p/rgGbQjUUJcQ8bZ",
];

export const stops = [
  {
    id: 1,
    name: "Erman Aras Çiftliği",
    region: "Mumcular",
    type: "Üretici",
    category: "bahce",
    signature: "Hasat Sofrası",
    description:
      "Bahçenin üretim hikâyesini, mevsim ritmini ve sofraya uzanan yolculuğu tanıtan üretici durağı.",
    lat: 37.0422,
    lng: 27.4305,
  },
  {
    id: 2,
    name: "Sıaeli",
    region: "Gümüşlük",
    type: "Restoran",
    category: "gastronomi",
    signature: "Mandalina Granita",
    description:
      "Gün batımına eşlik eden, kaynağı doğrulanacak Bodrum Mandarini granitası ve yerel menü hikâyesi.",
    lat: 37.0708,
    lng: 27.2856,
  },
  {
    id: 3,
    name: "Midtown Teras",
    region: "Bodrum Merkez",
    type: "Teras",
    category: "icecek",
    signature: "Mandalina & Defne Şerbeti",
    description:
      "Şehir merkezinde mandalina şerbeti ve aromatik yerel eşleşmeler üzerine kurgulanan rota durağı.",
    lat: 37.0344,
    lng: 27.4305,
  },
  {
    id: 4,
    name: "Yalı Mandalin Kafe",
    region: "Yalıkavak",
    type: "Kafe",
    category: "icecek",
    signature: "Mandalina Limonata",
    description:
      "Mandalinanın kabuk aromasını ve suyunu öne çıkaran ferah bir kıyı lezzeti.",
    lat: 37.1,
    lng: 27.3,
  },
  {
    id: 5,
    name: "Gündoğan Bahçe",
    region: "Gündoğan",
    type: "Restoran",
    category: "gastronomi",
    signature: "Mandalinalı Ceviche",
    description:
      "Narenciye asiditesini deniz ürünleriyle buluşturan imza tabak.",
    lat: 37.12,
    lng: 27.32,
  },
  {
    id: 6,
    name: "Türkbükü İskele",
    region: "Göltürkbükü",
    type: "Kıyı Durağı",
    category: "icecek",
    signature: "Mandalina Soğuk Çay",
    description:
      "İskele ritmine eşlik eden mandalina kabuğu, çay ve yerel otlarla hazırlanan soğuk demleme.",
    lat: 37.08,
    lng: 27.34,
  },
  {
    id: 7,
    name: "Torba Liman",
    region: "Torba",
    type: "Restoran",
    category: "gastronomi",
    signature: "Mandalina Glaze Balık",
    description:
      "Mandalina reduksiyonu ve Ege otlarını liman sofrasında buluşturan mevsimsel tabak.",
    lat: 37.06,
    lng: 27.38,
  },
  {
    id: 8,
    name: "Bitez Bahçe",
    region: "Bitez",
    type: "Kafe",
    category: "tatli",
    signature: "Mandalina Cheesecake",
    description:
      "Bitez bahçelerinin hafızasını modern bir tatlı yorumuna taşıyan gastronomi durağı.",
    lat: 37.02,
    lng: 27.35,
  },
  {
    id: 9,
    name: "Ortakent Sofra",
    region: "Ortakent",
    type: "Restoran",
    category: "tatli",
    signature: "Mandalina Sorbe",
    description:
      "Mandalinanın canlı asiditesini yalın bir sorbede öne çıkaran, mevsim bilgisi açık menü deneyimi.",
    lat: 37.0,
    lng: 27.32,
  },
  {
    id: 10,
    name: "Turgutreis Marina",
    region: "Turgutreis",
    type: "Marina Durağı",
    category: "icecek",
    signature: "Mandalina & Adaçayı Soda",
    description:
      "Batı kıyısında mandalina, adaçayı ve soda ile hazırlanan imza içeceği.",
    lat: 36.98,
    lng: 27.26,
  },
  {
    id: 11,
    name: "Akyarlar Kıyı",
    region: "Akyarlar",
    type: "Restoran",
    category: "gastronomi",
    signature: "Mandalinalı Levrek",
    description:
      "Kıyı ürününü Bodrum Mandarini aromasıyla eşleştiren, tedariki doğrulama kapsamındaki tabak.",
    lat: 36.96,
    lng: 27.28,
  },
  {
    id: 12,
    name: "Gümüşlük Değirmen",
    region: "Gümüşlük",
    type: "Kafe",
    category: "icecek",
    signature: "Mandalina Soğuk Demleme",
    description:
      "Tarihi değirmen rotasında kabuk aroması ve yavaş demleme tekniğini bir araya getiren içerik.",
    lat: 37.07,
    lng: 27.29,
  },
  {
    id: 13,
    name: "Yalıkavak Teras",
    region: "Yalıkavak",
    type: "Teras",
    category: "tatli",
    signature: "Mandalina Köpüğü",
    description:
      "Mandalinayı hafif bir tatlı dokusunda sunan, gün batımı rotasına eklenen teras durağı.",
    lat: 37.1,
    lng: 27.31,
  },
  {
    id: 14,
    name: "Gölköy Bahçe",
    region: "Göltürkbükü",
    type: "Restoran",
    category: "gastronomi",
    signature: "Mandalina Risotto",
    description:
      "Mandalina kabuğu, yerel otlar ve pirinci zeytin ağaçları altında buluşturan mevsimsel yorum.",
    lat: 37.09,
    lng: 27.33,
  },
  {
    id: 15,
    name: "Bodrum Yadigârı Bahçe",
    region: "Bodrum Merkez",
    type: "Bahçe",
    category: "bahce",
    signature: "Bahçe Turu & Tadım",
    description:
      "Ağaçtan ürüne giden süreci üretici anlatısıyla görünür kılan, mevsime bağlı bahçe deneyimi.",
    lat: 37.0344,
    lng: 27.418,
  },
  {
    id: 16,
    name: "Konacık Lokanta",
    region: "Konacık",
    type: "Lokanta",
    category: "gastronomi",
    signature: "Mandalinalı Kebap",
    description:
      "Yerel lokanta kültürünü mandalinanın dengeli asiditesiyle buluşturan sıcak tabak.",
    lat: 37.05,
    lng: 27.35,
  },
  {
    id: 17,
    name: "Bağla Koyu",
    region: "Bağla",
    type: "Kıyı Durağı",
    category: "icecek",
    signature: "Mandalina & Kekik Gazozu",
    description:
      "Saklı koy rotasında mandalina ve yerel kekiği birleştiren ferah gazoz.",
    lat: 37.01,
    lng: 27.36,
  },
].map((stop, index) => ({
  ...stop,
  mapLink: appleMapsLinks[index],
  verification: "RotaBodrum durağı",
}));

export const missions = [
  {
    stopId: 1,
    title: "Yaprağın haritası",
    prompt: "Bir mandalina yaprağının damarlarını ışığa karşı fotoğrafla.",
    clue: "Yakın plan çalış; kadraja insan veya özel bilgi alma.",
    theme: "leaf",
  },
  {
    stopId: 2,
    title: "Üç renkli ufuk",
    prompt: "Deniz, gökyüzü ve kıyının üç ayrı renk katmanını tek karede buluştur.",
    clue: "Ufuk çizgisini takip et; gün batımından hemen önce dene.",
    theme: "sunset",
  },
  {
    stopId: 3,
    title: "Şehirde yeşil iz",
    prompt: "Kent dokusu içinde saklanan dairesel veya dilimli bir form yakala.",
    clue: "Tabela yerine mimari detaylara ve gölgelere bak.",
    theme: "city",
  },
  {
    stopId: 4,
    title: "Yansımadaki Bodrum",
    prompt: "Mandalina rengini hatırlatan bir yansımayı su veya cam yüzeyde fotoğrafla.",
    clue: "Marka ve kişileri kadraj dışında bırak.",
    theme: "reflection",
  },
  {
    stopId: 5,
    title: "Ege eşleşmesi",
    prompt: "Mandalina dokusuyla bir Ege otunun dokusunu aynı karede eşleştir.",
    clue: "Ürüne dokunmadan, mevcut sunum veya bahçe detayını kullan.",
    theme: "herb",
  },
  {
    stopId: 6,
    title: "İskele geometrisi",
    prompt: "İskele çizgilerinin denize doğru oluşturduğu perspektifi yakala.",
    clue: "Güvenli alanda kal; yürüme hattını kapatma.",
    theme: "geometry",
  },
  {
    stopId: 7,
    title: "Kıyı paleti",
    prompt: "Yeşil, mavi ve mandalina tonunu tek bir kıyı karesinde bul.",
    clue: "Renkleri doğal çevrede ara; insanları fotoğraflama.",
    theme: "palette",
  },
  {
    stopId: 8,
    title: "Bahçe gölgesi",
    prompt: "Bir yaprağın masa, duvar veya zemin üzerindeki gölgesini fotoğrafla.",
    clue: "Sert öğle ışığı en belirgin silueti verir.",
    theme: "shadow",
  },
  {
    stopId: 9,
    title: "Sofranın ritmi",
    prompt: "Yuvarlak formların tekrar ettiği bir sofra düzeni yakala.",
    clue: "Kişisel eşya ve yüzler görünmeden kadrajla.",
    theme: "table",
  },
  {
    stopId: 10,
    title: "Rüzgârın yönü",
    prompt: "Rüzgârın hareket ettirdiği bir yaprak, kumaş veya su izini fotoğrafla.",
    clue: "Hareket hissi için telefonu sabit tut ve art arda birkaç kare dene.",
    theme: "wind",
  },
  {
    stopId: 11,
    title: "Kıyının dokusu",
    prompt: "Kum, taş ve bitkinin üç farklı dokusunu tek karede birleştir.",
    clue: "Doğal parçaları yerinden oynatmadan kompozisyon kur.",
    theme: "texture",
  },
  {
    stopId: 12,
    title: "Değirmen silueti",
    prompt: "Bir değirmen veya tarihî yapı çizgisini gökyüzüne karşı yakala.",
    clue: "Yapının tamamı yerine ayırt edici bir çizgiye odaklan.",
    theme: "heritage",
  },
  {
    stopId: 13,
    title: "Teras çerçevesi",
    prompt: "Bodrum manzarasını mimari bir açıklık veya doğal dal ile çerçevele.",
    clue: "Manzaraya derinlik veren ön plan öğesi bul.",
    theme: "frame",
  },
  {
    stopId: 14,
    title: "İki yaprak",
    prompt: "Zeytin ve mandalina yapraklarının biçim farkını aynı karede göster.",
    clue: "Bitkileri koparma; birbirine yakın doğal bir açı ara.",
    theme: "botany",
  },
  {
    stopId: 15,
    title: "Ağacın hafızası",
    prompt: "Yaşlı bir gövdenin çizgilerini ve kabuk dokusunu yakın planda yakala.",
    clue: "Dokuyu görünür kılmak için ışığı yandan al.",
    theme: "bark",
  },
  {
    stopId: 16,
    title: "Yerel el izi",
    prompt: "Bodrum’a özgü bir malzeme veya zanaat detayını fotoğrafla.",
    clue: "İzin gerektiren alanlarda önce işletmeye danış.",
    theme: "craft",
  },
  {
    stopId: 17,
    title: "Kekik ve deniz",
    prompt: "Kıyı bitkisini ön plana, denizi arka plana alan katmanlı bir kare çek.",
    clue: "Patikadan ayrılma ve bitkilere zarar verme.",
    theme: "coast",
  },
];

export const recipes = [
  {
    id: "serbet",
    index: "01",
    category: "İçecek",
    name: "Mandalina & Defne Şerbeti",
    summary: "Kabuk aromasını defne ve hafif baharatlarla dengeleyen soğuk servis.",
    time: "25 dk",
    season: "Yıl boyu · izlenebilir şurup",
    tone: "lime",
    ingredients: [
      "Bodrum Mandarini şurubu",
      "Taze defne yaprağı",
      "Su ve çok az şeker",
      "Servis için narenciye kabuğu",
    ],
  },
  {
    id: "sorbe",
    index: "02",
    category: "Tatlı & fırın",
    name: "Mandalina Sorbe",
    summary: "Meyvenin asiditesini saklayan, yalın ve ferah bir Mandalina Tarifleri klasiği.",
    time: "20 dk + dondurma",
    season: "Hasat / dondurulmuş püre",
    tone: "orange",
    ingredients: [
      "İzlenebilir mandalina püresi",
      "Su",
      "Az miktarda şeker",
      "Bir tutam tuz",
    ],
  },
  {
    id: "glaze",
    index: "03",
    category: "Sofra",
    name: "Mandalina Glaze",
    summary: "Balık, sebze ve sıcak tabaklarda kullanılabilen parlak narenciye sosu.",
    time: "18 dk",
    season: "Yıl boyu · izlenebilir ürün",
    tone: "green",
    ingredients: [
      "Mandalina suyu veya püresi",
      "Zeytinyağı",
      "Kekik",
      "Çok az sirke",
    ],
  },
  {
    id: "marmelat",
    index: "04",
    category: "Kiler",
    name: "Kabuklu Mandalina Marmeladı",
    summary: "Kabuğun eterik yağlarını ve meyvenin doğal dokusunu birlikte değerlendiren kiler tarifi.",
    time: "55 dk",
    season: "15 Aralık–Şubat",
    tone: "amber",
    ingredients: [
      "Taze Bodrum Mandarini",
      "Su",
      "Şeker",
      "Limon suyu",
    ],
  },
  {
    id: "kabuk",
    index: "05",
    category: "Sıfır atık",
    name: "Mandalina Kabuk Şekerlemesi",
    summary: "Kabuğu aromatik, uzun ömürlü bir atıştırmalığa dönüştüren basit teknik.",
    time: "45 dk",
    season: "Hasat dönemi",
    tone: "coral",
    ingredients: [
      "İyi yıkanmış mandalina kabuğu",
      "Su",
      "Şeker",
      "İsteğe bağlı bitter çikolata",
    ],
  },
  {
    id: "soda",
    index: "06",
    category: "Mekân imzası",
    name: "Mandalina & Adaçayı Soda",
    summary: "Mandalina şurubunu adaçayı ve yoğun mineralli soda ile katmanlayan ferah servis.",
    time: "8 dk",
    season: "Yıl boyu · izlenebilir şurup",
    tone: "blue",
    ingredients: [
      "Bodrum Mandarini şurubu",
      "Adaçayı demlemesi",
      "Soda",
      "Mandalina kabuğu",
    ],
  },
];
